/**
 * props:
 * - data: Faq[] {id, title, description}
 */
import DOMPurify from 'dompurify';

// descriptions are rendered as HTML, so every anchor must not leak the
// browsing context it opens
DOMPurify.addHook('afterSanitizeAttributes', node => {
    if (node.tagName === 'A' && node.getAttribute('href')) {
        node.setAttribute('rel', 'noopener noreferrer');
    }
});

const SANITIZE_CONFIG = {
    ALLOWED_TAGS: [
        'b',
        'i',
        'em',
        'strong',
        'a',
        'p',
        'ul',
        'ol',
        'li',
        'br',
        'code',
    ],
    ALLOWED_ATTR: ['href', 'target', 'rel'],
};

function Faq(props) {
    return (
        <>
            {props.data && props.data.length > 0 ? (
                <div className="bg-white rounded shadow p-5 mb-4 mt-4">
                    <h5>FAQs</h5>
                    <div className="row mt-1">
                        <div className="col-12">
                            <div className="accordion" id="accordionFaq">
                                {props.data.map(f => {
                                    return (
                                        <div
                                            className="accordion-item"
                                            key={f.id}
                                        >
                                            <h2
                                                className="accordion-header"
                                                id={'heading' + f.id}
                                            >
                                                <button
                                                    className="accordion-button collapsed"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={
                                                        '#collapse' + f.id
                                                    }
                                                    aria-expanded="false"
                                                    aria-controls={
                                                        'collapse' + f.id
                                                    }
                                                >
                                                    {f.title}
                                                </button>
                                            </h2>
                                            <div
                                                id={'collapse' + f.id}
                                                className="accordion-collapse collapse"
                                                aria-labelledby={
                                                    'heading' + f.id
                                                }
                                                data-bs-parent="#accordionFaq"
                                            >
                                                <div
                                                    className="accordion-body"
                                                    dangerouslySetInnerHTML={{
                                                        __html: DOMPurify.sanitize(
                                                            f.description,
                                                            SANITIZE_CONFIG,
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </>
    );
}

export default Faq;
